import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
/* Section Container */
export const DonationSummarySection = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 965px;
  width: 100%;
  margin: 0 auto;
`;
/* Main Container */
export const DonationSummaryContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 48px 36px 48px 48px;
  background-color: ${newColors.gray100dot30};
  border-radius: 18px;
  width: 100%;

  ${mediaq.md `
    padding: 40px 48px;
  `}

  ${mediaq.sm `
    padding: 0px 24px 40px;
    border-radius: 0;
  `}
`;
/* Header */
export const DonationSummaryHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  ${mediaq.sm `
    flex-direction: column;
  `}
`;
export const DonationSummaryInfo = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;

  ${mediaq.md `
    gap: 8px;
  `}
`;
export const DonationSummaryTitle = styled.h2 `
  color: ${newColors.gray800};
  font-family: 'Inria Serif', serif;
  font-size: 20px;
  font-weight: 700;
  margin: 0;

  ${mediaq.sm `
    display: none;
  `}
`;
export const DonationSummaryMobileTitle = styled.h2 `
  display: none;

  ${mediaq.sm `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    text-align: center;
    color: ${newColors.gray800};
    font-family: 'Inria Serif', serif;
    font-size: 18px;
    font-weight: 700;
    margin: 28px 0 0 0;
  `}
`;
export const DonationSummaryDonationCount = styled.span `
  color: ${newColors.gray500};
  font-size: 14px;
  font-weight: 400;
  margin: 0;

  ${mediaq.sm `
    display: none;
  `}
`;
/* Donate Button */
export const DonationSummaryDonateButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 8px 16px;
  height: 48px;
  min-width: 256px;
  background: ${newColors.purple500};
  color: ${newColors.snow};
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  &:hover {
    background-color: ${newColors.purple800};
  }
`;
/* Support Message */
export const DonationSummarySupportMessageContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px;
  background: ${newColors.snow};
  border-radius: 18px;

  & > svg {
    opacity: 0.6;
  }
`;
export const DonationSummarySupportMessage = styled.p `
  color: #6d6473;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  margin: 0;

  ${mediaq.sm `
    font-size: 14px;
  `}
`;
export const DonationSummarySupportButton = styled.button `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
  background: ${newColors.snow};
  color: ${newColors.purple500};
  font-size: 18px;
  font-weight: 500;
  text-decoration: underline;
  border: none;
  cursor: pointer;

  &:hover {
    color: ${newColors.purple800};
  }

  & > svg {
    position: absolute;
    right: -24px;
    transform: translateY(-1px);
  }

  ${mediaq.sm `
    font-size: 14px;
    gap: 2px;

    & > svg {
      width: 18px;
      height: 18px;
      right: -18px;
    }
  `}
`;
/* Donation List */
export const DonationSummaryList = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const DonationSummaryLoadMore = styled.button `
  background: transparent;
  color: ${newColors.purple500};
  font-size: 14px;
  border-radius: 9999px;
  border: 1px solid ${newColors.purple500};
  height: 48px;
  width: 256px;
  padding: 8px 16px;
  margin: 32px 0;
  &:hover {
    background: ${newColors.purple500};
    color: ${newColors.snow};
  }
`;
